// extracted by mini-css-extract-plugin
export default {"columnReverse":"Layout_columnReverse__302km"};